import { Fragment, FunctionalComponent, h } from '@stencil/core';
import { Labels, translate } from '../../../../../utils/translations';

interface MobileNavLinkProps {
  title: string;
  url?: string;
  externalLink?: boolean;
  onClick?: (event: MouseEvent) => void;
}

export const DsMobileNavigationLink: FunctionalComponent<MobileNavLinkProps> = ({
  url,
  title,
  externalLink = false,
  onClick
}) => (
  <ds-link
    class='link-item'
    type='secondary'
    href={url}
    target={externalLink ? '_blank' : null}
    onClick={onClick}
  >
    {title}
    {externalLink ? (
      <Fragment>
        <span class='link-item__external-label'>
          {translate(Labels['Navigation.LinkTargetBlank'])}
        </span>
        <ds-icon
          aria-hidden='true'
          name='ExternalLink'
          class='link-item__external-icon icon-wrapper'
        />
      </Fragment>
    ) : null}
  </ds-link>
);
